/* tslint:disable */
/* eslint-disable */

import { ConstSearch } from "@/contents/constants";

      // @ts-ignore
function fetchFromObject(obj:Object, prop:string) {
  if (typeof obj === 'undefined') {
    return false;
  }

  const _index = prop.indexOf('.');
  if (_index > -1) {
    return fetchFromObject(
      // @ts-ignore
      obj[prop.substring(0, _index)],
      prop.substr(_index + 1)
    );
  }

      // @ts-ignore
  return obj[prop];
}
var searchObject = function (
  object:Object,
  matchCallback:Function,
  currentPath?:any,
  result?:any,
  searched?:any
) {
  currentPath = currentPath || '';
  result = result || [];
  searched = searched || [];
  if (searched.indexOf(object) !== -1 && object === Object(object)) {
    return;
  }
  searched.push(object);
  if (matchCallback(object)) {
    result.push({ path: currentPath, value: object });
  }
  try {
    if (object === Object(object)) {
      for (const property in object) {
        if (property.indexOf('$') !== 0) {
          // if (Object.prototype.hasOwnProperty.call(object, property)) {
          searchObject(
           // @ts-ignore
            object[property],
            matchCallback,
            `${currentPath}.${property}`,
            result,
            searched
          );
          // }
        }
      }
    }
  } catch (e) {
    console.log(object);
    throw e;
  }
  return result;
};

export const valueToName = (value: string) => {
  try {
    const result = searchObject(ConstSearch, (item: any) => {
      if (isNaN(item)) {
        return item === value;
      } else {
        return `${item}` === value;
      }
    });
    if (result.length > 0) {
      const path = result[0].path;
      return fetchFromObject(
        ConstSearch,
        path.replace(/^\./g, "").replace(/value$/, "label")
      );
    }
    return "";
  } catch (e) {
    console.error(e);
    return "";
  }
};